import React, { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import PartnerDetailsForm from "./PartnerDetailsForm";
import PartnerDetailsView from "./PartnerDetailsView";

import backBtn from "../../assets/images/back-arrow.svg";
import { getRequest, patchRequest } from "../../api/http";
import userServiceApi from "../../api/userServiceApi";
import "./PartnerDetails.scss";
import { setOrgImageUrl } from "../../store/actions";
import { useStore } from "../../store";

import {
  FormOutlined, CloseOutlined, SaveOutlined, CheckOutlined
} from '@ant-design/icons';

function PartnerDetails() {
  const navigate = useNavigate();
  const { dispatch } = useStore();

  const partnerId = sessionStorage.getItem("partnerId");
  sessionStorage.setItem("page", "profile");

  const [loading, setLoading] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [partnerData, setPartnerData] = useState({});
  const [partnerType, setPartnerType] = useState([]);

  const fetchPartnerDetails = async () => {
    try {
      setLoading(true);
      const res = await getRequest(userServiceApi.partnerDetails());
      if (res?.data) {
        setPartnerData(res.data);
        sessionStorage.setItem("OrgImage", res?.data?.mediaLink);
        dispatch(setOrgImageUrl(res?.data?.mediaLink))
      }
    } catch (err) {
      toast.error("Failed to fetch partner details");
    } finally {
      setLoading(false);
    }
  };

  const fetchPartnerTypes = async () => {
    try {
      const res = await getRequest(
        userServiceApi.getAllPartnerTypes(partnerId)
      );
      if (res?.data) setPartnerType(res.data);
    } catch (err) {
      toast.error("Failed to fetch partner types");
    }
  };

  const handleResetWallpaper = async () => {
    try {
      const res = await patchRequest(
        userServiceApi.resetWallpaperToDefault(partnerId)
      );
      if (res?.defaultWallpaperUrl) {
        toast.success(res.message);
        fetchPartnerDetails();
      } else {
        toast.error("Unable to reset wallpaper to default.");
      }
    } catch (err) {
      toast.error("Error resetting wallpaper");
    }
  };

  const renderButtons = () => (
    <div className="iconButtonRow">
      <Button className="form-cancel-btn"  title="Cancel">
        <CloseOutlined onClick={() => setShowForm(false)} />
      </Button>
      <Button
        className="form-save-btn"
        htmlType="submit"
        form="partnerDetailsForm"
        title="Save"
      >
        {/* <SaveOutlined /> */}
        <CheckOutlined />
      </Button>
    </div>
  );

  useEffect(() => {
    fetchPartnerTypes();
    fetchPartnerDetails();
  }, []);

  if (loading) {
    return (
      <div className="data-loader">
        <Spin className="spin" tip="Loading" size="large" />
      </div>
    );
  }

  return (
    <div className="tabContainer">
      <div className="main-container" style={{ paddingTop: "5px" }}>
        <div className="header-container" style={{ justifyContent: "normal" }}>
          <div className="backbtn-container">
            <img
              src={backBtn}
              onClick={() => navigate("/partner-org")}
              alt="back"
            />
            <p>Profile</p>
          </div>

        </div>

        <div className="profile-card-container">

          <div className="partnerInfoStyle">

            <div>
              {!showForm ? (
                <div className="formOutlinedBtn" title="Edit">
                  <FormOutlined
                    onClick={() => {
                      setShowForm(true);
                      fetchPartnerDetails();
                    }}
                  />
                </div>
              ) : (
                renderButtons()
              )}
            </div>

            {showForm ? (
              <>
                <PartnerDetailsForm
                  setLoading={setLoading}
                  partnerData={partnerData}
                  partnerTypes={partnerType}
                  fetchPartnerDetails={fetchPartnerDetails}
                  setShowForm={setShowForm}
                  handleResetWallpaper={handleResetWallpaper}
                />
                {/* {renderButtons()} */}
              </>
            ) : (
              <PartnerDetailsView partnerData={partnerData} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PartnerDetails;
